"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import { Component, useContext } from "react";
import { Router, Route, matchPath, __RouterContext } from "react-router";
import { Link as RouterLink } from "react-router-dom";
import { dequal } from "dequal";
import {
  toLocation
} from "./legacy_history";
function matchRoutes(routes, pathname, underLayout) {
  const atRoot = underLayout && pathname === "/";
  for (const route of routes) {
    const allPaths = Array.isArray(route.path) ? route.path : [route.path];
    const paths = atRoot ? allPaths.filter((path) => path === "/") : allPaths;
    for (const path of paths) {
      const match = matchPath(pathname, { path, exact: true });
      if (match) return { route, params: match.params };
    }
  }
  return null;
}
function enterHook(route) {
  if (!route.redirectTo) return route.onEnter;
  const pathname = route.redirectTo;
  return ({ location }, replace) => replace({ pathname, query: location.query, state: location.state });
}
function createTransitionHistory(history, routes, underLayout) {
  let committed;
  const listeners = /* @__PURE__ */ new Set();
  function transitionTo(location) {
    const match = matchRoutes(routes, location.pathname, underLayout);
    const layoutOnly = underLayout && location.pathname === "/";
    if (!match && !layoutOnly && committed) return;
    const previous = committed == null ? void 0 : committed.match;
    const entering = match && ((previous == null ? void 0 : previous.route) !== match.route || !dequal(previous.params, match.params));
    const onEnter = entering ? enterHook(match.route) : void 0;
    let redirect = null;
    onEnter == null ? void 0 : onEnter({ location, params: match.params }, (to) => redirect = to);
    if (redirect) {
      history.replace(redirect);
      return;
    }
    committed = { location, match };
    listeners.forEach((listener) => listener(location));
  }
  const stopListening = history.listen(transitionTo);
  transitionTo(history.getCurrentLocation());
  return Object.create(history, {
    location: { get: () => committed.location },
    listen: {
      value: (listener) => {
        listeners.add(listener);
        return () => listeners.delete(listener);
      }
    },
    stop: { value: stopListening },
    match: {
      value: (pathname) => matchRoutes(routes, pathname, underLayout)
    }
  });
}
export default class LegacyRouter extends Component {
  constructor() {
    super(...arguments);
    // Routes are read once, as react-router 3 ignored changes to them.
    __publicField(this, "transitions", createTransitionHistory(
      this.props.history,
      this.props.routes,
      !!this.props.layout
    ));
  }
  componentWillUnmount() {
    this.transitions.stop();
  }
  render() {
    const { layout: Layout } = this.props;
    return /* @__PURE__ */ jsx(Router, { history: this.transitions, children: /* @__PURE__ */ jsx(
      Route,
      {
        render: ({ location }) => {
          const match = this.transitions.match(location.pathname);
          if (!match && Layout && location.pathname === "/") {
            return /* @__PURE__ */ jsx(Layout, { location, params: {} });
          }
          if (!(match == null ? void 0 : match.route.component)) return null;
          const props = { location, params: match.params };
          const Page = match.route.component;
          if (!Layout) return /* @__PURE__ */ jsx(Page, __spreadValues({}, props));
          return /* @__PURE__ */ jsx(Layout, __spreadProps(__spreadValues({}, props), { children: /* @__PURE__ */ jsx(Page, __spreadValues({}, props)) }));
        }
      }
    ) });
  }
}
export function Link(_a) {
  var _b = _a, { to } = _b, props = __objRest(_b, ["to"]);
  const router = useContext(__RouterContext);
  if (!router) return /* @__PURE__ */ jsx("a", __spreadValues({}, props));
  return /* @__PURE__ */ jsx(RouterLink, __spreadValues({ to: toLocation(to) }, props));
}
